import none from "./none";

export default function(series) {
  return none(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-shape/src/order/reverse.js
// module id = ../../../../d3-shape/src/order/reverse.js
// module chunks = 3